// extracted by mini-css-extract-plugin
export default {"info-text":"bggdgE","infoText":"bggdgE","info-text-new-view":"rjKW7U","infoTextNewView":"rjKW7U"};